import React from 'react';
import './Text.scss';

export default function Text(props) {
  const { text, className } = props;
  return <p className={`text text-grey ${className}`}>{text}</p>;
}
